import AppDashboard from '../AppDashboard';
import {useGetSessionTypeTemplatesQuery} from '../../redux/services/sessionTypeTemplateApi';
import ListTemplatesScreen from '../../components/scheduling/ListTemplatesScreen';

const ListSessionTypeTemplatesPage = () => {
  const query = useGetSessionTypeTemplatesQuery({});
  const templates = query?.data?.data || [];
  const isLoading = query.isLoading || query.isFetching;
  return (
    <AppDashboard 
      title="Session Type Templates"
      isLoading={isLoading}
    >
      <ListTemplatesScreen templates={templates} />
    </AppDashboard>
  );
};

export default ListSessionTypeTemplatesPage;